import { AdminPage } from "./pages/AdminPage";
import { BookingPage } from "./pages/BookingPage";
import { TicketPage } from "./pages/TicketPage";

export function App() {
  const path = window.location.pathname;
  if (path === "/admin" || path === "/admin/") return <AdminPage />;
  if (/^\/ticket\/[^/]+\/?$/.test(path)) return <TicketPage />;
  return <BookingPage />;
}
